// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jro0","rootNoMargin":"styles_rootNoMargin__2NsGT"};